export const DailyLogLogEvent = {
  DAILY_LOG_ONBOARDING_SCREEN_VIEWED: {
    amp: 'Daily Log Onboarding - Screen Viewed',
    ga: 'daily_log_onboarding_screen_viewed',
  },
  DAILY_LOG_ONBOARDING_BUTTON_CLICKED: {
    amp: 'Daily Log Onboarding - Button Clicked',
    ga: 'daily_log_onboarding_button_clicked',
  },
  DAILY_LOG_ONBOARDING_SHARE_CLICKED: {
    amp: 'Daily Log Onboarding - Share Clicked',
    ga: 'daily_log_onboarding_share_clicked',
  },
  // [로그 디테일] 화면 진입
  DAILY_LOG_DETAIL_SCREEN_VIEWED: {
    amp: 'Daily Log Detail - Screen Viewed',
    ga: 'daily_log_detail_screen_viewed',
  },
  // [로그 디테일] app install top banner 클릭
  DAILY_LOG_DETAIL_APP_INSTALL_TOP_BANNER_CLICKED: {
    amp: 'Daily Log Detail - App Install Top Banner Clicked',
    ga: 'daily_log_detail_app_install_top_banner_clicked',
  },
  // [로그 디테일] Follow 버튼 클릭
  DAILY_LOG_DETAIL_FOLLOW_BUTTON_CLICKED: {
    amp: 'Daily Log Detail - Follow Button Clicked',
    ga: 'daily_log_detail_follow_button_clicked',
  },
  // [로그 디테일] 리액션 입력 클릭(sticker || memo)
  DAILY_LOG_DETAIL_REACTION_INPUT_CLICKED: {
    amp: 'Daily Log Detail - Reaction Input Clicked',
    ga: 'daily_log_detail_reaction_input_clicked',
  },
  // [로그 디테일] 추천 스티커 선택
  DAILY_LOG_DETAIL_RECOMMEND_STICKER_SELECTED: {
    amp: 'Daily Log Detail - Recommend Sticker Selected',
    ga: 'daily_log_detail_recommend_sticker_selected',
  },
  // [로그 디테일] 리액션 정렬 버튼 클릭
  DAILY_LOG_DETAIL_REACTION_SORT_BUTTON_CLICKED: {
    amp: 'Daily Log Detail - Reaction Sort Button Clicked',
    ga: 'daily_log_detail_reaction_sort_button_clicked',
  },

  // [로그 디테일] 내 스티커 스토리 만들기 배너 클릭
  DAILY_LOG_DETAIL_MAKE_STICKER_STORY_BANNER_CLICKED: {
    amp: 'Daily Log Detail - Make Sticker Story Banner Clicked',
    ga: 'daily_log_detail_make_sticker_story_banner_clicked',
  },

  // [로그 디테일 리액션] 옵션 클릭
  DAILY_LOG_DETAIL_REACTION_OPTION_CLICKED: {
    amp: 'Daily Log Detail Reaction - Option Clicked',
    ga: 'daily_log_detail_reaction_option_clicked',
  },
  // [로그 디테일 리액션] 리액션 아이템 클릭
  DAILY_LOG_DETAIL_REACTION_REACTION_ITEM_CLICKED: {
    amp: 'Daily Log Detail Reaction - Reaction Item Clicked',
    ga: 'daily_log_detail_reaction_reaction_item_clicked',
  },
  // [로그 디테일 리액션] 리액션 삭제 버튼 클릭
  DAILY_LOG_DETAIL_REACTION_DELETE_BUTTON_CLICKED: {
    amp: 'Daily Log Detail - Reaction Delete Button Clicked',
    ga: 'daily_log_detail_reaction_delete_button_clicked',
  },
  //[로그 디테일 리액션] 다음 버튼 클릭
  DAILY_LOG_DETAIL_REACTION_NEXT_BUTTON_CLICKED: {
    amp: 'Daily Log Detail Reaction - Next Button Clicked',
    ga: 'daily_log_detail_reaction_next_button_clicked',
  },
  // [로그 디테일 리액션] 완료 버튼 클릭
  DAILY_LOG_DETAIL_REACTION_SUBMIT_BUTTON_CLICKED: {
    amp: 'Daily Log Detail Reaction - Submit Button Clicked',
    ga: 'daily_log_detail_reaction_submit_button_clicked',
  },
  // [로그 디테일 리액션] 이름 입력 모달 노출
  DAILY_LOG_DETAIL_REACTION_NAME_INPUT_MODAL_VIEWED: {
    amp: 'Daily Log Detail Reaction - Name Input Modal Viewed',
    ga: 'daily_log_detail_reaction_name_input_modal_viewed',
  },
  // [로그 디테일 리액션] 이름 입력 모달 닫기 버튼 클릭
  DAILY_LOG_DETAIL_REACTION_NAME_INPUT_MODAL_CLOSE_BUTTON_CLICKED: {
    amp: 'Daily Log Detail Reaction - Name Input Modal Close Button Clicked',
    ga: 'daily_log_detail_reaction_name_input_modal_close_button_clicked',
  },
  // [로그 디테일 리액션] 이름 입력 모달 완료 버튼 클릭
  DAILY_LOG_DETAIL_REACTION_NAME_INPUT_MODAL_SUBMIT_BUTTON_CLICKED: {
    amp: 'Daily Log Detail Reaction - Name Input Modal Submit Button Clicked',
    ga: 'daily_log_detail_reaction_name_input_modal_submit_button_clicked',
  },
  // [로그 디테일] 스티커 키보드 toggle 버튼 클릭
  DAILY_LOG_DETAIL_STICKER_KEYBOARD_TOGGLE_BUTTON_CLICKED: {
    amp: 'Daily Log Detail - Sticker Keyboard Toggle Button Clicked',
    ga: 'daily_log_detail_sticker_keyboard_toggle_button_clicked',
  },
  // [로그 디테일] 공유 UI 노출
  DAILY_LOG_DETAIL_SHARE_UI_IMPRESSED: {
    amp: 'Daily Log Detail - Share UI Impressed',
    ga: 'daily_log_detail_share_ui_impressed',
  },
  // [로그 디테일] 복사 버튼 클릭
  DAILY_LOG_DETAIL_SHARE_COPY_BUTTON_CLICKED: {
    amp: 'Daily Log Detail - Share Copy Button Clicked',
    ga: 'daily_log_detail_share_copy_button_clicked',
  },
  // [로그 디테일] 로그인 버튼 클릭
  DAILY_LOG_DETAIL_LOGIN_BUTTON_CLICKED: {
    amp: 'Daily Log Detail - Login Button Clicked',
    ga: 'daily_log_detail_login_button_clicked',
  },
  // [로그 디테일] 예시 배너 노출
  DAILY_LOG_DETAIL_EXAMPLE_BANNER_IMPRESSED: {
    amp: 'Daily Log Detail - Example Banner Impressed',
    ga: 'daily_log_detail_example_banner_impressed',
  },
  // [로그 디테일] 예시 배너 클릭
  DAILY_LOG_DETAIL_EXAMPLE_BANNER_CLICKED: {
    amp: 'Daily Log Detail - Example Banner Clicked',
    ga: 'daily_log_detail_example_banner_clicked',
  },
  // [로그 디테일] 나도 만들러 가기 노출
  DAILY_LOG_DETAIL_CREATE_TEMPLATE_BUTTON_VIEWED: {
    amp: 'Daily Log Detail - Create Template Button Viewed',
    ga: 'daily_log_detail_create_template_button_viewed',
  },
  // [로그 디테일] 나도 만들러 가기 클릭
  DAILY_LOG_DETAIL_CREATE_TEMPLATE_BUTTON_CLICKED: {
    amp: 'Daily Log Detail - Create Template Button Clicked',
    ga: 'daily_log_detail_create_template_button_clicked',
  },
  // [로그 디테일] 스티커(리액션) 클릭
  DAILY_LOG_DETAIL_REACTION_CLICKED: {
    amp: 'Daily Log Detail - Reaction Clicked',
    ga: 'daily_log_detail_reaction_clicked',
  },
  // [로그 템플릿] 화면 진입
  DAILY_LOG_TEMPLATE_SCREEN_VIEWED: {
    amp: 'Daily Log Template - Screen Viewed',
    ga: 'daily_log_template_screen_viewed',
  },
  // [로그 템플릿] 템플릿 클릭
  DAILY_LOG_TEMPLATE_TEMPLATE_CLICKED: {
    amp: 'Daily Log Template - Template Clicked',
    ga: 'daily_log_template_template_clicked',
  },
  // [로그 템플릿] 템플릿 로그인 모달 노출
  DAILY_LOG_TEMPLATE_LOGIN_MODAL_VIEWED: {
    amp: 'Daily Log Template - Login Modal Viewed',
    ga: 'daily_log_template_login_modal_viewed',
  },
  // [로그 템플릿] 템플릿 로그인 모달 - 로그인 버튼 클릭
  DAILY_LOG_TEMPLATE_LOGIN_MODAL_LOGIN_BUTTON_CLICKED: {
    amp: 'Daily Log Template - Login Modal Login Button Clicked',
    ga: 'daily_log_template_login_modal_login_button_clicked',
  },
  // [로그 템플릿] 템플릿 로그인 모달 - 익명 버튼 클릭
  DAILY_LOG_TEMPLATE_LOGIN_MODAL_ANONYMOUS_BUTTON_CLICKED: {
    amp: 'Daily Log Template - Login Modal Anonymous Button Clicked',
    ga: 'daily_log_template_login_modal_anonymous_button_clicked',
  },
  // [로그 템플릿] 이름 입력 모달 노출
  DAILY_LOG_TEMPLATE_NAME_INPUT_MODAL_VIEWED: {
    amp: 'Daily Log Template - Name Input Modal Viewed',
    ga: 'daily_log_template_name_input_modal_viewed',
  },
  // [로그 템플릿] 이름 입력 모달 - submit 클릭
  DAILY_LOG_TEMPLATE_NAME_INPUT_MODAL_SUBMIT_BUTTON_CLICKED: {
    amp: 'Daily Log Template - Name Input Modal Submit Button Clicked',
    ga: 'daily_log_template_name_input_modal_submit_button_clicked',
  },
  // [로그 템플릿] 예시 배너 클릭
  DAILY_LOG_TEMPLATE_EXAMPLE_BANNER_CLICKED: {
    amp: 'Daily Log Template - Example Banner Clicked',
    ga: 'daily_log_template_example_banner_clicked',
  },
  //[로그 디테일] 나만 보기 버튼 노출 (웹 only)
  DAILY_LOG_DETAIL_REACTION_PRIVATE_TOGGLE_BUTTON_VIEWED: {
    amp: 'Daily Log Detail - Reaction Private Toggle Button Viewed',
    ga: 'daily_log_detail_reaction_private_toggle_button_viewed',
  },
  //[로그 디테일] 나만 보기 버튼 토글 (웹 only)
  DAILY_LOG_DETAIL_REACTION_PRIVATE_TOGGLE_BUTTON_CLICKED: {
    amp: 'Daily Log Detail - Reaction Private Toggle Button Clicked',
    ga: 'daily_log_detail_reaction_private_toggle_button_clicked',
  },
  //[로그 디테일] 스티커 비공개 버튼 클릭 (웹 only)
  DAILY_LOG_DETAIL_REACTION_PRIVATE_BUTTON_CLICKED: {
    amp: 'Daily Log Detail - Reaction Private Button Clicked',
    ga: 'daily_log_detail_reaction_private_button_clicked',
  },
  //[로그 템플릿] 튜토리얼 종료
  DAILY_LOG_TEMPLATE_TUTORIAL_FINISHED: {
    amp: 'Daily Log Template - Tutorial Finished',
    ga: 'daily_log_template_tutorial_finished',
  },
  // [로그 디테일] 튜토리얼 종료
  DAILY_LOG_DETAIL_TUTORIAL_FINISHED: {
    amp: 'Daily Log Detail - Tutorial Finished',
    ga: 'daily_log_detail_tutorial_finished',
  },
  //로그 디테일 공유 모달 노출
  DAILY_LOG_DETAIL_SHARE_MODAL_VIEWED: {
    amp: 'Daily Log Detail - Share Modal Viewed',
    ga: 'daily_log_detail_share_modal_viewed',
  },
  //로그 디테일 공유 모달 복사 클릭
  DAILY_LOG_DETAIL_SHARE_MODAL_COPY_BUTTON_CLICKED: {
    amp: 'Daily Log Detail - Share Modal Copy Button Clicked',
    ga: 'daily_log_detail_share_modal_copy_button_clicked',
  },
  //로그 디테일 공유 모달 공유 버튼 클릭
  DAILY_LOG_DETAIL_SHARE_MODAL_SHARE_BUTTON_CLICKED: {
    amp: 'Daily Log Detail - Share Modal Share Button Clicked',
    ga: 'daily_log_detail_share_modal_share_button_clicked',
  },
}
